/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Show_PasswordInputs */

const en_common_show_password = /** @type {(inputs: Common_Show_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show password`)
};

const es_common_show_password = /** @type {(inputs: Common_Show_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar contraseña`)
};

/**
* | output |
* | --- |
* | "Show password" |
*
* @param {Common_Show_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_show_password = /** @type {((inputs?: Common_Show_PasswordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Show_PasswordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_show_password(inputs)
	return en_common_show_password(inputs)
});